import React, { useState, useRef, useCallback, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import {
  selectFilteredWorkTickets,
  selectWorkTicketFilterVisible,
  selectWorkTicketLoading,
  selectfetchWorkTicketLoading,
} from './store/selectors';
import VirtualList from '../components/VirtualList'; // Import VirtualList
import LoadingSpinner from '../../InitialPage/Sidebar/LoadingSpinner'; // Import LoadingSpinner
import { isHeaderVisible } from 'Core/redux/main/selectors';
import { Edit, Trash2 } from 'react-feather';
import { Button, ButtonGroup } from 'react-bootstrap';
import { editWorkTicketData } from './store/slice';
import withReactContent from 'sweetalert2-react-content';
import Swal from 'sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';

const WorkTicketTile = props => {
  const [columnCount, setColumnCount] = useState(6);
  const [columnWidth, setColumnWidth] = useState(300);
  const workTicketTileRef = useRef(null);

  const filteredWorkTickets = useSelector(selectFilteredWorkTickets);
  const isLoading = useSelector(selectWorkTicketLoading);
  const filterVisible = useSelector(selectWorkTicketFilterVisible);
  const isFetchDataLoading = useSelector(selectfetchWorkTicketLoading);
  const headerVisible = useSelector(isHeaderVisible);

  const updateColumnSettings = useCallback(() => {
    if (workTicketTileRef.current) {
      const width = workTicketTileRef.current.offsetWidth;
      let columns = 6;

      if (width < 576) {
        columns = 1; // Mobile
      } else if (width < 768) {
        columns = 3; // Tablets
      } else if (width < 992) {
        columns = 5; // Large screens
      } else {
        columns = 6; // Extra large screens
      }

      setColumnCount(columns);
      setColumnWidth(width / columns);
    }
  }, []);

  useEffect(() => {
    updateColumnSettings();
    window.addEventListener('resize', updateColumnSettings);
    return () => window.removeEventListener('resize', updateColumnSettings);
  }, [updateColumnSettings]);

  const itemData = filteredWorkTickets.map(workTicket => <Tile workTicket={workTicket} />);
  return (
    <div
      className={`tile-body ${filterVisible ? 'filter-visible' : ''} ${
        !headerVisible ? 'header-collapsed' : ''
      }`}
      ref={workTicketTileRef}
    >
      {(isLoading || isFetchDataLoading) && <LoadingSpinner />}
      {
        <VirtualList
          columnCount={columnCount}
          rowCount={Math.ceil(filteredWorkTickets.length / columnCount)}
          itemData={itemData}
          columnWidth={columnWidth}
          rowHeight={150} // Adjusted row height
        />
      }
    </div>
  );
};
const MySwal = withReactContent(Swal);

const Tile = ({ workTicket }) => {
  const dispatch = useDispatch();

  const handleEdit = e => {
    e.stopPropagation();
    dispatch(editWorkTicketData(workTicket.workorderid));
  };

  // const handleDelete = async () => {
  //   const result = await Swal.fire({
  //     title: 'Are you sure?',
  //     text: "You won't be able to revert this!",
  //     icon: 'warning',
  //     showCancelButton: true,
  //     confirmButtonColor: '#3085d6',
  //     cancelButtonColor: '#d33',
  //     confirmButtonText: 'Yes, delete it!',
  //   });

  //   if (result.isConfirmed) {
  //     dispatch(deleteWorkTicket(workTicket.workorderid));
  //   }
  // };

  return (
    <div key={workTicket.workorderid || Math.random()} className="tile">
      <div
        className={`card p-3 m-2 ${workTicket.isNewlyCreated ? 'border-success' : ''}`}
        style={{
          border: '1px solid #ddd',
          borderRadius: '4px',
          boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
        }}
      >
        <div className="tile-actions">
          <ButtonGroup size="sm">
            <Button variant="light" onClick={handleEdit}>
              <Edit size={16} />
            </Button>
            {/* <Button variant="light" onClick={handleDelete}>
              <Trash2 size={16} />
            </Button> */}
          </ButtonGroup>
        </div>
        <div className="d-flex justify-content-between">
          <div className="d-flex flex-row align-items-center">
            <div className="ms-2 c-details">
              <h6 className="mb-0">{workTicket.workorderid} </h6>
              <span>{workTicket.standarD_ID}</span>
            </div>
          </div>
        </div>
        <div className="mt-1">
          <span
            className="badge"
            style={{
              backgroundColor: workTicket.backgroundColor || '#e0e0e0',
              color: workTicket.textColor || '#000000',
            }}
          >
            {workTicket.firm || 'N/A'}
          </span>
        </div>
        <div className="mt-1">
          <h5 className="heading"> {workTicket.wtname}</h5>
        </div>
      </div>
    </div>
  );
};
export default WorkTicketTile;
